/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable radix */
import React from 'react';
import InputMask from 'react-input-mask';

import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

import { ALL_TIME_ZONE } from '../../../../core/utils/timezone';

export const STORE_FIELDS = Object.freeze({
  CNPJ: 'cnpj',
  NAME: 'name',
  WEBSITE_URL: 'websiteUrl',
  MONTHLY_ORDERS: 'monthlyOrders',
  TIME_ZONE: 'timezone',
  EMAIL: 'email',
  COMPLEMENT: 'addrComplement',
  TELEPHONE: 'telephone',
  STREET: 'addrStreet',
  CITY: 'addrCity',
  NUMBER: 'addrNumber',
  ADDR_DISTRICT: 'addrDistrict',
  STATE: 'addrState',
  ZIP_CODE: 'addrZipCode',
  IMAGE_URL: 'imageUrl',
});

export default function FormStore({ onChange, formState, formError }) {
  const {
    NAME,
    WEBSITE_URL,
    MONTHLY_ORDERS,
    TIME_ZONE,
    EMAIL,
    TELEPHONE,
    CNPJ,
  } = STORE_FIELDS;

  return (
    <>
      <InputMask
        mask="99.999.999/9999-99"
        maskPlaceholder={null}
        value={formState[CNPJ]}
        onChange={(e) => onChange(CNPJ, e.target.value)}
      >
        {(inputProps) => (
          <TextField
            {...inputProps}
            id="outlined-basic"
            label="CNPJ *"
            variant="outlined"
            error={!!formError[CNPJ]}
            helperText={formError[CNPJ]}
          />
        )}
      </InputMask>

      <TextField
        id="outlined-basic"
        label="Nome da Organização *"
        variant="outlined"
        value={formState[NAME]}
        onChange={(e) => onChange(NAME, e.target.value)}
        error={!!formError[NAME]}
        helperText={formError[NAME]}
      />
      <TextField
        id="outlined-basic"
        label="Website *"
        variant="outlined"
        value={formState[WEBSITE_URL]}
        onChange={(e) => onChange(WEBSITE_URL, e.target.value)}
        error={!!formError[WEBSITE_URL]}
        helperText={formError[WEBSITE_URL]}
      />
      <TextField
        id="outlined-basic"
        label="Pedidos mensais *"
        variant="outlined"
        type="number"
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        value={formState[MONTHLY_ORDERS]}
        onChange={(e) =>
          onChange(
            MONTHLY_ORDERS,
            parseInt(
              e.target.value
                .replace(/[^0-9.]/g, '')
                .replace(/(\..*?)\..*/g, '$1'),
            ),
          )
        }
        error={!!formError[MONTHLY_ORDERS]}
        helperText={formError[MONTHLY_ORDERS]}
      />
      <FormControl sx={{ m: 0, width: '100%' }}>
        <InputLabel id="demo-simple-select-helper-label">Timezone</InputLabel>
        <Select
          variant="outlined"
          id="demo-simple-select-helper"
          label="Timezone *"
          SelectDisplayProps={{ heigth: 300 }}
          value={formState[TIME_ZONE]}
          onChange={(e) => onChange(TIME_ZONE, e.target.value)}
          error={!!formError[TIME_ZONE]}
        >
          {ALL_TIME_ZONE.map((timezone) => (
            <MenuItem key={timezone.value} value={timezone.value}>
              {timezone.name}
            </MenuItem>
          ))}
        </Select>
        {formError[TIME_ZONE] && (
          <FormHelperText>{formError[TIME_ZONE]}</FormHelperText>
        )}
      </FormControl>
      <TextField
        id="outlined-basic"
        label="Email *"
        variant="outlined"
        value={formState[EMAIL]}
        onChange={(e) => onChange(EMAIL, e.target.value)}
        error={!!formError[EMAIL]}
        helperText={formError[EMAIL]}
      />

      <InputMask
        mask="(99) 99999-9999"
        maskPlaceholder={null}
        value={formState[TELEPHONE]}
        onChange={(e) => onChange(TELEPHONE, e.target.value)}
      >
        {(inputProps) => (
          <TextField
            {...inputProps}
            id="outlined-basic"
            label="Telefone *"
            variant="outlined"
            error={!!formError[TELEPHONE]}
            helperText={formError[TELEPHONE]}
          />
        )}
      </InputMask>
    </>
  );
}

FormStore.propTypes = {
  onChange: PropTypes.func.isRequired,
  formState: PropTypes.objectOf(PropTypes.string).isRequired,
  formError: PropTypes.objectOf(PropTypes.string).isRequired,
};
